export const FIN_PARAMLOAD_PARAM = 'FIN_PARAMLOAD_PARAM';
export const CHANGE_ENV_PARAM = 'CHANGE_ENV_PARAM';
export const CHANGE_REGION_PARAM = 'CHANGE_REGION_PARAM';

export function finParamLoadAction(isFin) {
    return {
        type: FIN_PARAMLOAD_PARAM,
        isFin: isFin
    };
}

export function changeEnvAction(data) {
    return {
        type: CHANGE_ENV_PARAM,
        data: data
    };
}

export function changeRegionAction(data) {
    return {
        type: CHANGE_REGION_PARAM,
        data: data
    };
}